const ANALYTICS_EVENT = 'Mentett keresések';

export const SavedSearches = {
	templateUrl: 'saved-searches.html',
	transclude: true,
	controller: class SavedSearches {
		constructor($mdDialog, SearchesService) {
			'ngInject';
			this.$mdDialog = $mdDialog;
			this.searchesService = SearchesService;
			this.model = {};
		}

		$onInit() {
			if (!this.initialized) {
				this.getSavedSearches();
				this.initialized = true;
			}
		}

		$onChanges() {
		}

		loadPage(event) {
			this.pager(event.pageTo, this.size);
		}

		pager(page, size) {
			let params = {
				page: page,
				size: size
			};
			this.getSavedSearches(params);
		}

		editSearch(search, $index) {
			this.selectedSearch = search;
			this.selectedSearchIndex = $index;
			this.model.name = this.selectedSearch.name;
			this.model.sendNotificationEmail = this.selectedSearch.sendNotificationEmail;
			this.$mdDialog.show({
				templateUrl: 'saved-search-edit-name.html',
				clickOutsideToClose: true,
				controller:()=>this,
				controllerAs: '$ctrl'
			});
		}

		showDeleteSearch(search) {
			this.selectedSearch = search ? search : null;
			this.$mdDialog.show({
				templateUrl: 'saved-search-delete.html',
				clickOutsideToClose: true,
				controller:()=>this,
				controllerAs: '$ctrl'
			});
		}

		closePopup(type) {
			this.notifications = {};
			this.$mdDialog.hide();
		}

		getSavedSearches(params) {
			this.searchesService.getSavedSearches(params).then((response)=>{
				this.responseData = response.data;
				this.numOfSavedSearches = response.data.totalElements;
				this.savedSearches = response.data.content;
				this.size = response.data.size;
				this.currentPage = response.data.number;
			}).catch(() => {
				// valami fosódás van
			});
		}

		renameSavedSearch() {
			let data = {
				name: this.model.name,
				sendNotificationEmail: this.model.sendNotificationEmail
			};
			this.searchesService.renameSearch(this.selectedSearch.id, data).then((response) => {
				this.closePopup();
				this.savedSearches[this.selectedSearchIndex] = response.data;
			}).catch((error) => {
				console.log(error);
				this.closePopup();
			});
		}

		getRowNum(index) {
			return parseInt(index + 1 + this.currentPage * this.size, 10);
		}

		deleteSearch(id) {
			this.searchesService.deleteSearch(id).then(() => {
				this.notifications = {
					message: 'Sikeres törlés.'
				};
				this.getSavedSearches();
			}).catch(() => {
				this.notifications = {
					message: 'Sikertelen törlés.'
				};
			});
		}

		startSavedSearch($event, search) {
			$event.preventDefault();
			$event.stopPropagation();
			window.dataLayer.push({
				event: 'startSavedSearch',
				searchName: search.name
			});
			setTimeout(() => {
				window.location.href = search.url;
			}, 500);
		}

		newSearch($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
		}
	}
};
